// src/component/Layout/BreadcrumbContext.jsx
//
// Lets a page name itself in the TopHeader trail ("Home / Properties /
// Riverside Court"). TopHeader's BREADCRUMBS map only knows fixed paths, so
// every /:entity/:id route used to read "Home / Page". A detail page calls
// useBreadcrumb([{ label: 'Properties', to: '/properties' }, { label: name }])
// once its record has loaded; the trail clears when the page unmounts.
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const BreadcrumbContext = createContext({ trail: null, setTrail: () => {} });

export function BreadcrumbProvider({ children }) {
  const [trail, setTrail] = useState(null);
  const value = useMemo(() => ({ trail, setTrail }), [trail]);
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}

export function useBreadcrumbTrail() {
  return useContext(BreadcrumbContext).trail;
}

// `trail` is an array of { label, to? }; pass null while the record loads.
// Keyed on the labels so a re-render with an equal trail does not loop.
export function useBreadcrumb(trail) {
  const { setTrail } = useContext(BreadcrumbContext);
  const key = trail ? JSON.stringify(trail) : '';
  useEffect(() => {
    setTrail(key ? JSON.parse(key) : null);
    return () => setTrail(null);
  }, [key, setTrail]);
}

// The label for a path the map does not know: the longest map entry that is
// a path prefix ("/properties/abc" → "Properties"), else null.
export function prefixLabel(map, pathname) {
  let best = null;
  Object.keys(map).forEach((path) => {
    if (pathname.startsWith(`${path}/`) && (!best || path.length > best.length)) best = path;
  });
  return best ? map[best] : null;
}
